import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-no-modules-page',
    templateUrl: './no-modules-page.component.html',
    styleUrls: ['./no-modules-page.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NoModulesPageComponent {}
